module.exports = __webpack_public_path__ + "static/media/mastercard.04f5f20e.svg";